export default class Storage {
  static get(key, fallback = null) {
    const value = sessionStorage.getItem(key) || fallback;

    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  static set(key, value) {
    sessionStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : value);
  }

  static remove(...keys) {
    keys.forEach(key => sessionStorage.removeItem(key));
  }

  static clear() {
    sessionStorage.clear();
  }
}
